// extracted by mini-css-extract-plugin
export default {"Bar":"styles_Bar__VSt9y","FillBar":"styles_FillBar__PO8Za"};